/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { Editor } from 'cio/services/editor';

interface CioSwitchEditorArgs {
  editor: Editor;
  onSetEditor: (editor: Editor) => unknown;
  disabled: boolean;
}

export default class CioSwitchEditor extends Component<CioSwitchEditorArgs> {
  @tracked showSwitchToRichTextModal = false;
  @tracked showSwitchToCodeModal = false;

  @action
  setEditor(value: Editor) {
    this.args.onSetEditor(value);

    this.showSwitchToCodeModal = false;
    this.showSwitchToRichTextModal = false;
  }

  @action
  confirmSwitch(editor: Editor) {
    if (this.args.editor === editor) {
      return;
    }

    if (editor === Editor.RICH_TEXT) {
      this.showSwitchToRichTextModal = true;
    } else if (editor === Editor.CODE) {
      this.showSwitchToCodeModal = true;
    }
  }
}
